import { useUnit } from 'effector-react';
import { useEffect } from 'react';
import { $activeChatHexagons } from '../../models/chatModel/index.js';
import { $mapLoaded } from '../../models/mapModel/index.js';
import {
  $isPreset,
  changeConfirmModalEv,
} from '../../models/rbpLiteModel/index.js';
import {
  changeLayerVisibility,
  changePointerOnLayer,
} from '../../utils/mapbox-utils.js';

const onClick = (e) => {
  changeConfirmModalEv({
    id: '',
    type: 'Feature',
    properties: {},
    geometry: {
      type: 'Point',
      coordinates: [e.lngLat.lng, e.lngLat.lat],
    },
  });
};

function LiteChatHexagons() {
  const hexagons = useUnit($activeChatHexagons);
  const mapLoaded = useUnit($mapLoaded);
  const isPreset = useUnit($isPreset);

  const createLayer = (update) => {
    const hexagonsData = {
      type: 'FeatureCollection',
      features: hexagons,
    };
    if (update) {
      window.map.getSource('chat_hexagons_source').setData(hexagonsData);
    } else {
      if (!window.map.getSource('chat_hexagons_source')) {
        window.map.addSource('chat_hexagons_source', {
          type: 'geojson',
          data: hexagonsData,
        });
      }

      if (!window.map.getLayer('chat_hexagons_layer')) {
        window.map.addLayer({
          id: 'chat_hexagons_layer',
          type: 'fill-extrusion',
          source: 'chat_hexagons_source',
          paint: {
            'fill-extrusion-color': 'rgba(0, 0, 0, 0)',
            'fill-extrusion-opacity': 0,
          },
        });

        window.map.addLayer({
          id: 'chat_hexagons_outline',
          type: 'line',
          source: 'chat_hexagons_source',
          paint: {
            'line-color': 'black',
            'line-width': 5,
          },
        });
      }

      window.map.on('click', 'chat_hexagons_layer', onClick);
      changePointerOnLayer('chat_hexagons_layer', true);
      // changeLayerVisibility('chat_hexagons_layer', false);
    }
  };

  useEffect(() => {
    if (mapLoaded && hexagons.length > 0) {
      if (window.map.getLayer('chat_hexagons_layer')) {
        createLayer(true);
      } else {
        setTimeout(() => {
          createLayer(false);
        }, 500);
      }
    }
  }, [mapLoaded, hexagons]);

  useEffect(() => {
    if (mapLoaded && window.map.getLayer('chat_hexagons_layer')) {
      if (hexagons.length > 0) {
        changeLayerVisibility('chat_hexagons_layer', true);
        changeLayerVisibility('chat_hexagons_outline', true);
      } else {
        changeLayerVisibility('chat_hexagons_layer', false);
        changeLayerVisibility('chat_hexagons_outline', false);
      }
    }
  }, [mapLoaded, hexagons]);

  useEffect(() => {
    if (mapLoaded && window.map.getLayer('chat_hexagons_layer')) {
      changeLayerVisibility('chat_hexagons_layer', false);
      changeLayerVisibility('chat_hexagons_outline', false);
    }
  }, [mapLoaded, isPreset]);

  return <div />;
}

export default LiteChatHexagons;
